import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import navLogo from '../assets/logo-saigrp1.png';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setMenuOpen(false);

  return (
    <header>
      <nav className="navbar">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo">
            <img src={navLogo} alt="Logo" />
          </Link>
        </div>
        <button
          className="hamburger"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
        <ul className={`navbar-links${menuOpen ? " open" : ""}`}>
          <li>
            <Link
              to="/"
              className={`navbar-link${location.pathname === '/' ? " active" : ""}`}
              onClick={closeMenu}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={`navbar-link${location.pathname === '/about' ? " active" : ""}`}
              onClick={closeMenu}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/products"
              className={`navbar-link${location.pathname === '/products' ? " active" : ""}`}
              onClick={closeMenu}
            >
              Our Products
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={`navbar-link${location.pathname === '/contact' ? " active" : ""}`}
              onClick={closeMenu}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
